import React from 'react';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-conectiva-navy text-white pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          
          {/* Lado Esquerdo: Contato e Infos */}
          <div>
            <div className="flex items-center gap-2 mb-6">
               <span className="text-2xl font-bold tracking-tighter">
                CONNECTIVA<span className="text-conectiva-lime">.</span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Formando profissionais de excelência para cuidar do futuro. Venha fazer parte da revolução na saúde.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-gray-300">
                <MapPin className="text-conectiva-lime" size={20} />
                <span>Nazaré da Mata – PE</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Phone className="text-conectiva-lime" size={20} />
                <span>(81) 99272-3717</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Mail className="text-conectiva-lime" size={20} />
                <span>contato@escolaconectiva.com.br</span>
              </div>
            </div>

            <div className="flex gap-4 mt-8">
              <a href="https://www.instagram.com/connectivatec/" className="bg-white/10 p-2 rounded-full hover:bg-conectiva-lime hover:text-conectiva-navy transition">
                <Instagram size={20} />
              </a>
              {/* <a href="#" className="bg-white/10 p-2 rounded-full hover:bg-conectiva-lime hover:text-conectiva-navy transition">
                <Facebook size={20} />
              </a> */}
            </div>
          </div>

          {/* Lado Direito: Mapa (Google Maps Embed) */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10 h-[300px]">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31610.96348128212!2d-35.2894578!3d-7.7386659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ab6a65381395b7%3A0x6e937d5982877a06!2sNazar%C3%A9%20da%20Mata%2C%20PE%2C%2055800-000!5e0!3m2!1spt-BR!2sbr!4v1709825478952!5m2!1spt-BR!2sbr" 
              width="100%" 
              height="100%" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-500">
          &copy; 2026 Escola Técnica Connectiva. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}